import React, {useState, useContext} from 'react';
import {Maybe} from 'monet';
import * as R from 'ramda';
import {Row, Col} from 'reactstrap';
import {useFixedTranslation} from '@/i18n';
import Select from '@/Form/Select';
import Icon from '@/views/shared/Icon';
import DownloadFileButton from '@/views/shared/DownloadFileButton';
import {present} from '@/util';

import {PolicyStatementCtx} from '@/b2b/contexts';
import {getCurrentPolicy} from '@/b2b/pages/PolicyStatement/state';

const SelectMonth = () => {
  const [state] = useContext(PolicyStatementCtx);
  const {partyId, statementLanguage} = state;
  const currentPolicy = getCurrentPolicy(state);
  const tr = useFixedTranslation(statementLanguage, 'statement');

  const [month, setMonth] = useState('');
  const monthOptions = R.propOr([], 'monthOptions', currentPolicy);
  const buildSelectOptions = R.map(([key, val]) => (
    <option value={val} key={val}>
      {key}
    </option>
  ));

  const onChangeMonth = e => {
    setMonth(e.currentTarget.value);
  };

  const downloadPath = R.ifElse(
    present,
    R.always(
      `/statement/download_monthly_statement?month=${month}&party_id=${partyId}`
    ),
    R.always(`/statement/${partyId}.pdf`)
  )(month);

  const Content = () => (
    <>
      <Row>
        <Col md='auto' className='pr-1 pt-1'>
          {tr('choose_month')}
        </Col>
        <Col md={2} className='px-0'>
          <Select name='selectedMonth' onChange={onChangeMonth} value={month}>
            {buildSelectOptions(monthOptions)}
          </Select>
        </Col>
        <Col md={2} className='pl-1 pt-1'>
          <small>{tr('pdf_version')}</small>
          <DownloadFileButton
            className='btn btn-link btn-sm'
            path={downloadPath}
          >
            <Icon icon='file-pdf' />{' '}
          </DownloadFileButton>
        </Col>
      </Row>
      <p className='px-0 mt-2'>{tr('last_6_month_remarks')}</p>
    </>
  );

  return Maybe.fromFalsy(currentPolicy.accountType !== 'CONSOLIDATE')
    .map(() => <Content />)
    .orNull();
};

export default SelectMonth;
